<template>
  <div id="app">
    <!--div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div-->
    <router-view />
  </div>
</template>
<script>

import { AppService } from './service/main'
export default {
  name: "App",
  data() {
    return {
      label: [],
    };
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      var setLang = 1;
      if (typeof this.$route.params.lang === "undefined") {
        setLang = 1;
      } else {
        if (this.$route.params.lang == "en") {
          setLang = 1;
        } else if (this.$route.params.lang == "id") {
          setLang = 2;
        } else {
          setLang = 6;
        }
      }
      await AppService.getLabel('label', setLang)
        .then((response) => {
          this.$store.commit("savelabel", response.content);
        })
        .catch((e) => {
          console.log(e)
        })
      await AppService.getConfig('config')
        .then((response) => {
          this.$store.commit("saveconfig", response.content);
        })
        .catch((e) => {
          console.log(e)
        })
      await AppService.getMenu('menu', setLang)
        .then((response) => {
          this.$store.commit("savemenu", response.content);
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
};
</script>
<style>
#app {
  font-family: "Quicksand", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

button {
  -webkit-border-radius: 15px !important;
  -moz-border-radius: 15px !important;
  border-radius: 15px !important;
  margin-top: 10px !important;
}

#loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

#loader {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 75px;
  height: 75px;
  margin: -75px 0 0 -45px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #109bf8;

  -webkit-animation: spin 0.8s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 0.8s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */

  z-index: 1001;
}

#loader:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  right: 4px;
  bottom: 4px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #df27a5;

  -webkit-animation: spin 1.8s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 1.8s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */
}

#loader:after {
  content: "";
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  bottom: 12px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #000;

  -webkit-animation: spin 1.3s linear infinite;
  /* Chrome, Opera 15+, Safari 5+ */
  animation: spin 1.3s linear infinite;
  /* Chrome, Firefox 16+, IE 10+, Opera */
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}

#loader-wrapper .loader-section {
  position: fixed;
  top: 0;
  width: 51%;
  height: 100%;
  background: #fff;
  z-index: 1000;
  -webkit-transform: translateX(0);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(0);
  /* IE 9 */
  transform: translateX(0);
  /* Firefox 16+, IE 10+, Opera */
}

#loader-wrapper .loader-section.section-left {
  left: 0;
}

#loader-wrapper .loader-section.section-right {
  right: 0;
}

/* Loaded */
.loaded #loader-wrapper .loader-section.section-left {
  -webkit-transform: translateX(-100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(-100%);
  /* IE 9 */
  transform: translateX(-100%);
  /* Firefox 16+, IE 10+, Opera */

  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.loaded #loader-wrapper .loader-section.section-right {
  -webkit-transform: translateX(100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateX(100%);
  /* IE 9 */
  transform: translateX(100%);
  /* Firefox 16+, IE 10+, Opera */

  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.loaded #loader {
  opacity: 0;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}

.loaded #loader-wrapper {
  visibility: hidden;

  -webkit-transform: translateY(-100%);
  /* Chrome, Opera 15+, Safari 3.1+ */
  -ms-transform: translateY(-100%);
  /* IE 9 */
  transform: translateY(-100%);
  /* Firefox 16+, IE 10+, Opera */

  -webkit-transition: all 0.3s 1s ease-out;
  transition: all 0.3s 1s ease-out;
}

/* JavaScript Turned Off */
.no-js #loader-wrapper {
  display: none;
}

.no-js h1 {
  color: #222222;
}

/* GLOBAL */
.btn-magenta {
  font-size: 0.9em !important;
  font-weight: 700 !important;
  padding: 10px 20px !important;
  background: #ff1493 !important;
  border: solid 1px #f50f8b !important;
  -webkit-box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 0.5) !important;
  -moz-box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 0.5) !important;
  box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 0.5) !important;
}

.btn-magenta:hover {
  background: #db127f !important;
  border: solid 1px #f50f8b !important;
  -webkit-box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 1) !important;
  -moz-box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 1) !important;
  box-shadow: 0px 0px 25px -5px rgba(255, 20, 147, 1) !important;
  /* -webkit-box-shadow: 0px 11px 50px -15px rgba(252,61,166,1);
-moz-box-shadow: 0px 11px 50px -15px rgba(252,61,166,1);
box-shadow: 0px 11px 50px -15px rgba(252,61,166,1);
*/
}

.btn-blue {
  font-size: 0.9em !important;
  font-weight: 700 !important;
  padding: 10px 20px !important;
  background: #3eb1f2 !important;
  border: solid 1px #38aaeb !important;
  /*
  -webkit-box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);
  -moz-box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);
  box-shadow: 0px 11px 50px -10px rgba(62, 177, 242, 1);*/
  -webkit-box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 0.5) !important;
  -moz-box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 0.5) !important;
  box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 0.5) !important;
}

.btn-blue:hover {
  background: #309edb !important;
  border: solid 1px #38aaeb !important;
  -webkit-box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 1) !important;
  -moz-box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 1) !important;
  box-shadow: 0px 0px 25px -5px rgba(62, 177, 242, 1) !important;
}

.btn-transparent {
  font-size: 0.9em !important;
  font-weight: 700 !important;
  padding: 10px 20px !important;
  background: none !important;
  border: solid 1px #fff !important;
}

.btn-transparent:hover,
.btn-transparent:active,
.btn-transparent:visited,
.btn-transparent:focus {
  background: rgba(255, 255, 255, 0.1) !important;
  border: solid 1px #fff !important;
}

.btn-noborder {
  border: none !important;
}

.btn-noborder:hover {
  border: none !important;
}

.btn-white {
  font-size: 0.9em !important;
  font-weight: 700 !important;
  padding: 10px 20px !important;
  background: none !important;
  border: solid 1px #fff !important;
  color: #3eb1f2 !important;
}

.btn-white:hover {
  background: rgba(150, 150, 150, 0.1) !important;
  border: solid 1px #fff !important;
  color: #3eb1f2 !important;
}

.content-button {
  margin-top: 25px;
}

.p-20 {
  padding: 20px;
}

.content-box-white {
  margin-top: 15px;
  text-align: left;
}

.content-box-white h2 {
  margin-top: 30px;
  color: #133d54;
  font-weight: bold;
  margin-bottom: 30px;
}

.content-box-white h2 span {
  color: #3eb1f2;
}

.content-box-white p {
  color: #6e7f89;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 0.9em;
}

.content-box-white .content-section {
  margin-top: 50px;
  margin-bottom: 25px;
}

.content-box-grey {
  position: relative;
  min-height: 750px;
  overflow: hidden;
  text-align: left;
  margin-top: -110px;
}

.content-box-grey h2 {
  margin-top: 30px;
  color: #133d54;
  font-weight: bold;
}

.content-box-grey h2 span {
  color: #3eb1f2;
}

.content-box-grey p {
  color: #6e7f89;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 0.9em;
}

.content-box-grey .content-section {
  margin-top: 175px;
  margin-bottom: 25px;
}

.header__bg_grey {
  margin-top: 100px;
  position: absolute;
  right: 0;
  left: 0;
  width: 100%;
  min-height: 650px;
  background-image: linear-gradient(to right, #f5f9fa, #f5f9fa);
  transform: skewY(-2deg);
  transform-origin: top left;
}

.content-box-blue {
  position: relative;
  min-height: 450px;
  /*overflow: hidden; */
  text-align: left;
  display: flex;
}

.header__bg_blue {
  margin-top: 100px;
  position: absolute;
  right: 0;
  left: 0;
  width: 100%;
  min-height: 300px;
  height: 98%;
  background-image: linear-gradient(to right, #109bf8, #57b2c4);
  transform: skewY(-2deg);
  transform-origin: top left;
}

.content-box-blue .margin-box {
  margin-top: 120px;
  margin-bottom: 100px;
}

.content-box-blue h2 {
  margin-top: 30px;
  color: #fff;
  font-weight: bold;
}

.content-box-blue h2 span {
  color: #133d54;
}

.content-box-blue p {
  color: #fff;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 0.9em;
}

.content-box-blue p a,
.content-box-blue p a:hover {
  color: #fff;
}

.content-box-blue .content-section {
  margin-top: 75px;
  margin-bottom: 25px;
}

.m-t-150 {
  margin-top: 150px !important;
}

/* blue dark */
.content-box-blue-dark {
  position: relative;
  min-height: 700px;
  overflow: hidden;
  text-align: left;
}

.header__bg_blue_dark {
  margin-top: 100px;
  position: absolute;
  right: 0;
  left: 0;
  width: 100%;
  min-height: 600px;
  background: rgb(at 70% 40%, 43, 189, 188);
  background: radial-gradient(at 70% 40%,
      rgba(43, 189, 188, 1) 17%,
      rgba(41, 129, 156, 1) 45%,
      rgba(45, 95, 137, 1) 100%);
  transform: skewY(-2deg);
  transform-origin: top left;
}

.content-box-blue-dark .margin-box {
  margin-top: 180px;
}

.content-box-blue-dark h2 {
  margin-top: 30px;
  color: #fff;
  font-weight: bold;
}

.content-box-blue-dark h2 span {
  color: #133d54;
}

.content-box-blue-dark p {
  color: #fff;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 0.9em;
}

.content-box-blue-dark .content-section {
  margin-top: 150px;
  margin-bottom: 25px;
}

/* blue dark */
/* company */
.content-box-company {
  position: relative;
  min-height: 650px;
  overflow: hidden;
  text-align: left;
  /* background-image: url("https://www.sentineltech.com/assets/images/CompanyOverviewNew.png"); */
  background-size: 100% 100%;
  margin-top: -120px;
}

.lazy-background-image {
  height: auto;
  min-height: 650px;
}

.lazy-background {
  height: 0 !important;
}

.content-box-company .margin-box {
  margin-top: 180px;
}

.content-box-company h2 {
  margin-top: 30px;
  color: #27a5f5;
  font-weight: bold;
}

.content-box-company h2 span {
  color: #133d54;
}

.content-box-company p {
  color: #fff;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 0 200px;
  font-size: 0.9em;
}

.content-box-company .content-section {
  margin-top: 100px;
  margin-bottom: 25px;
}

/* company */
.content-area {
  padding: 5px 30px;
}

.content-box-blue img {
  max-width: 500px;
  margin: -70px auto;
}

.content-box-white .makesmall {
  max-width: 425px;
  margin: -40px auto;
}

.makebig {
  max-width: 600px;
  margin-top: -90px;
}

.content-center p {
  margin: 0 75px;
}

.content-box-blue ul,
.content-box-blue ul li,
.content-box-blue ul li a {
  color: #fff !important;
}

.max-width-auto {
  max-width: 250px !important;
  margin: 0 auto !important;
}

.partner-logo {
  background: #fff;
  overflow: auto;
  /* padding: 20px; */
  margin-top: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.img-center {
  margin: 0 auto !important;
}

.h-feature {
  position: relative;
  padding-bottom: 20px;
}

.img-features {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding: 50px;
  margin: 10px !important;
  /*
  -webkit-box-shadow: 9px 9px 50px -35px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 9px 9px 50px -35px rgba(0, 0, 0, 0.75);
  box-shadow: 9px 9px 50px -35px rgba(0, 0, 0, 0.75);
  */
}

.features-box {
  margin-top: 25px;
  margin-bottom: 25px;
}

.features-box h4 {
  font-size: 1.3em;
  font-weight: bold;
  background: #fff;
  padding: 7px 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  /*
  border-left: solid 8px #ff1493;
  color: #133d54;
  background: #fafafa;
  padding: 7px 12px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  */
}

.features-box p {
  margin: 10px 25px;
}

.features-box a,
.features-box a:hover {
  text-decoration: none;
  color: #133d54;
}

.features-box .zoom {
  transition: transform 0.2s;
  /* Animation */
  cursor: pointer;
}

.features-box .zoom:hover {
  transform: scale(1.5);
}

.features-box ul {
  color: #fff;
}

.price-box {
  border: #bfbfbf;
  -webkit-box-shadow: 9px 9px 50px -25px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 9px 9px 50px -25px rgba(0, 0, 0, 0.75);
  box-shadow: 9px 9px 50px -25px rgba(0, 0, 0, 0.75);
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  margin-bottom: 65px;
  background: #fff;
}

.price-box .price-header {
  -webkit-border-top-left-radius: 15px;
  -webkit-border-top-right-radius: 15px;
  -moz-border-radius-topleft: 15px;
  -moz-border-radius-topright: 15px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 10px;
  font-size: 1.3em;
  text-align: center;
  font-weight: bold;
  color: #fff;
}

.price-box .price-show {
  padding: 10px;
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
}

.price-box .price-show span {
  font-size: 0.7em;
}

.price-box .price-content {
  padding: 15px 10px 0;
  min-height: 300px;
  position: relative;
}

.price-box .price-content .addons {
  position: absolute;
  bottom: 0;
}

.price-box .price-content ul {
  padding-left: 20px;
  font-size: 0.8em;
}

.price-box .price-footer {
  -webkit-border-bottom-right-radius: 15px;
  -webkit-border-bottom-left-radius: 15px;
  -moz-border-radius-bottomright: 15px;
  -moz-border-radius-bottomleft: 15px;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  padding: 20px 10px;
  text-align: center;
}

.btn-pricing-contact {
  -webkit-border-radius: 15px !important;
  -moz-border-radius: 15px !important;
  border-radius: 15px !important;
  color: #fff !important;
  font-weight: bold !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.color-indigo {
  background: #3f51b5 !important;
}

.color-blue {
  background: #2196f3 !important;
}

.color-teal {
  background: #004d40 !important;
}

.color-green {
  background: #1b5e20 !important;
}

.color-grey {
  background: #eceff1 !important;
}

.m-top-105 {
  /* margin-top: -105px; */
}

.h2-bigger {
  font-size: 2.5em;
}

/* Zooming entrances */
@-webkit-keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.85, 0.85, 0.85);
    transform: scale3d(0.85, 0.85, 0.85);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.85, 0.85, 0.85);
    transform: scale3d(0.85, 0.85, 0.85);
  }

  50% {
    opacity: 1;
  }
}

.animate__zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-75px, 0, 0);
    transform: translate3d(-75px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-75px, 0, 0);
    transform: translate3d(-75px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(75px, 0, 0);
    transform: translate3d(75px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(75px, 0, 0);
    transform: translate3d(75px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

@media (max-width: 768px) {
  .content-box-blue img {
    max-width: 425px;
    margin: 40px auto;
  }

  .header__bg_blue {
    min-height: 450px;
  }

  .header__bg_blue_dark {
    min-height: 950px;
  }

  .content-box-grey {
    margin-top: -190px;
  }

  .header__bg_grey {
    min-height: 1000px;
  }

  .content-center p {
    margin: 0 5px;
  }

  .content-box-company p {
    padding: 0 10px;
  }

  .content-box-company {
    margin-top: -40px;
  }

  .content-box-company,
  .lazy-background-image {
    background-repeat: no-repeat;
    background-size: 100%;
    background-size: cover;
    background-position: center;
  }

  .btn-blue,
  .btn-magenta,
  .btn-transparent,
  .btn-white {
    font-size: 0.8em;
  }

  .makebig {
    max-width: 400px;
    margin-top: 0;
  }

  .header__bg_blue_dark {
    background: rgb(at 70% 40%, 43, 189, 188);
    background: radial-gradient(at 50% 100%,
        rgba(43, 189, 188, 1) 27%,
        rgba(41, 129, 156, 1) 55%,
        rgba(45, 95, 137, 1) 100%);
  }

  .partner-logo {
    padding: 5px;
  }
}</style>
